import React, { Component } from 'react';
import Bio from './bio'
import { PureComponent } from 'react';

class PlayerShortStats extends PureComponent {

    constructor(props) {
        super(props);
        // this.autoComplete.bind(this)

    }





    render() {
        let { player, getTrans, trans } = this.props;
        return (
            <div className="si-plyr__stats">
                <div className="si-stats__col">
                    <div className="si-stats__title">{getTrans(trans, "selPer", "Selected by %")}</div>
                    <div className="si-stats__data">{player.selPer}%</div>
                </div>
                <div className="si-stats__col">
                    <div className="si-stats__title">{getTrans(trans, "totPoints", "Total points")}</div>
                    <div className="si-stats__data">{player.totPts + " " + getTrans(trans, "pts", "pts")}</div>
                </div>
                <div className="si-stats__col">
                    <div className="si-stats__title">{getTrans(trans, "price", "Price")}</div>
                    <div className="si-stats__data">€{player.value} {getTrans(trans, "million_short", "m")} </div>
                </div>
            </div>
        )
    }
}

export default PlayerShortStats;

